import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import OnboardingLayout from '../components/OnboardingLayout';
import VerifyEmailBanner from '../components/VerifyEmailBanner';
import SchoolAutocomplete from '../components/SchoolAutocomplete';
import { Button } from '../components/ui/button';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const OnboardingSchool = () => {
  const navigate = useNavigate();
  const { user, loading, updateOnboarding } = useAuth();
  const [place, setPlace] = useState(null);
  const [saving, setSaving] = useState(false);

  if (loading) return null;
  if (!user) {
    navigate('/signup', { replace: true });
    return null;
  }

  const saveAndContinue = async () => {
    if (!place) {
      navigate('/onboarding/move-in');
      return;
    }
    setSaving(true);
    try {
      await updateOnboarding({
        school_name: place.name,
        school_place_id: place.place_id,
        school_lat: place.lat,
        school_lng: place.lng,
      });
      navigate('/onboarding/move-in');
    } catch (e) {
      toast.error("We couldn't save that. Try again in a moment.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <VerifyEmailBanner />
      <OnboardingLayout
        step={1}
        title="Which school will you be attending?"
        subtitle="This helps us show you places nearby with commute times."
        testId="onboarding-school"
      >
        <SchoolAutocomplete
          onSelect={setPlace}
          placeholder="Start typing your school name…"
          className="[&_input]:h-12"
        />
        {place && (
          <p className="mt-3 text-sm text-slate-600" data-testid="selected-school">
            Selected: <span className="font-semibold text-slate-900">{place.name}</span>
          </p>
        )}

        <div className="mt-8 space-y-3">
          <Button
            onClick={saveAndContinue}
            disabled={saving}
            className="w-full h-12 btn-primary text-base"
            data-testid="school-continue-btn"
          >
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Continue
          </Button>
          <button
            onClick={() => navigate('/onboarding/move-in')}
            className="w-full text-sm text-slate-600 hover:text-slate-900 py-2"
            data-testid="school-skip-link"
          >
            Skip this step
          </button>
        </div>
      </OnboardingLayout>
    </>
  );
};

export default OnboardingSchool;
